










import Vue from 'vue';
import { Component } from 'vue-property-decorator';
@Component({
    components: {
        Info: () => import('./components/info.vue'),
        CourseList: () => import('./components/course-list.vue')
    }
})
export default class Detail extends Vue {}
